module.exports = new __parcel__URL__("swiftrenewal.2eddbd0d.png").toString();